import React from 'react'
import './index.css'
import FlexColumn from 'components/FlexColumn'
import logUtil from 'utils/log'
import useSelector from 'hooks/use-selector'
import getSummaryDataByMemberId from 'modules/squad/redux/selectors/get-summary-data-by-member-id'
import getCurrentMemberIdSquadSelect from 'modules/squad/redux/selectors/get-current-member-id'
import ItemsYouBothLovedContent from 'pages/Squad/containers/Friends/CurrentFriendSampleSummary/Content/ItemsYouBothLoved/Content'
import ItemsYouBothLovedEmpty from 'pages/Squad/containers/Friends/CurrentFriendSampleSummary/Content/ItemsYouBothLoved/Empty'

export default function ItemsYouBothLoved () {
  const currentMemberId = useSelector(getCurrentMemberIdSquadSelect)
  /**
   * @type import('modules/squad/types').SquadSummaryData
   */
  const summaryData = useSelector(getSummaryDataByMemberId(currentMemberId))
  const debugProps = {
    summaryData
  }
  const itemsYouBothLoved = summaryData?.items_you_both_loved
  logUtil('ItemsYouBothLoved').debug('debugProps=', debugProps)

  if (!itemsYouBothLoved?.length) {
    return <ItemsYouBothLovedEmpty />
  }

  return (
    <FlexColumn
      className='squad-items-you-both-loved'
    >
      <ItemsYouBothLovedContent itemsYouBothLoved={itemsYouBothLoved} />
    </FlexColumn>
  )
}
